;(() => {
	const getTrack = ($section) =>
		$section.find("[data-mx-image-links-carousel-track]")
	const getImagesPerView = (sliderImagesPerRow) => {
		const desktopCols = parseInt(sliderImagesPerRow, 10)
		const safeDesktopCols =
			Number.isFinite(desktopCols) && desktopCols > 0 ? desktopCols : 3

		if (window.innerWidth >= 1024) {
			return safeDesktopCols
		}
		if (window.innerWidth >= 768) {
			return 2
		}
		return 1
	}

	Shopify.theme.jsMxImageLinksCarousel = {
		init: function ($section) {
			const sectionData = Shopify.theme.getSectionData($section)
			Shopify.theme.jsMxImageLinksCarousel = $.extend(this, sectionData)

			if (this.display_mode !== "slider") {
				return
			}

			const $track = getTrack($section)
			if (!$track.length || typeof $track.flickity !== "function") {
				return
			}

			const cellCount = $track.find(
				".mx-image-links-carousel__cell",
			).length
			if (cellCount < 2) {
				return
			}

			const imagesPerView = getImagesPerView(this.slider_images_per_row)
			const hasOverflow = cellCount > imagesPerView
			const wrapAround = this.slider_infinite === true && hasOverflow

			const flktyOptions = {
				accessibility: true,
				contain: true,
				draggable: hasOverflow,
				imagesLoaded: true,
				prevNextButtons: this.show_arrows === true && hasOverflow,
				pageDots: this.show_dots === true && hasOverflow,
				cellAlign: "left",
				wrapAround: wrapAround,
				percentPosition: true,
				setGallerySize: true,
				selectedAttraction: 0.02,
				friction: 0.28,
			}

			const flickityInstance = $track
				.flickity(flktyOptions)
				.data("flickity")
			$section.data("mxImageLinksCarouselFlickity", flickityInstance)

			const sectionId = $section.attr("id")
			const resizeEventName = `resize.${sectionId}.mxImageLinksCarousel`
			const settleHandler = () => flickityInstance.resize()

			$track.on("settle.flickity", settleHandler)
			$(window).on(resizeEventName, settleHandler)

			$section.data("mxImageLinksCarouselResizeEvent", resizeEventName)
			$section.data("mxImageLinksCarouselSettleHandler", settleHandler)
		},

		unload: function ($section) {
			const $track = getTrack($section)
			if (!$track.length || typeof $track.flickity !== "function") {
				return
			}

			const resizeEventName = $section.data(
				"mxImageLinksCarouselResizeEvent",
			)
			const settleHandler = $section.data(
				"mxImageLinksCarouselSettleHandler",
			)

			if (settleHandler) {
				$track.off("settle.flickity", settleHandler)
			}
			if (resizeEventName) {
				$(window).off(resizeEventName)
			}

			const flickityInstance = $section.data(
				"mxImageLinksCarouselFlickity",
			)
			if (flickityInstance) {
				$track.flickity("destroy")
			}

			$section.removeData("mxImageLinksCarouselFlickity")
			$section.removeData("mxImageLinksCarouselResizeEvent")
			$section.removeData("mxImageLinksCarouselSettleHandler")
		},
	}
})()
